export default __webpack_public_path__ + "static/media/dropverse_palette_1.png";